import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <h1 class=\"stickytarget\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"headLine") : stack1), depth0)) != null ? stack1 : "")
    + "</h1>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <p class=\"stickytarget\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"copyText") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"show-for-small-only\">\n  <img class=\"hero-image\" aria-hidden=\"true\" alt=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"backgroundImage") : stack1)) != null ? lookupProperty(stack1,"altTag") : stack1), depth0))
    + "\" src=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"backgroundImage") : stack1)) != null ? lookupProperty(stack1,"srcSmall") : stack1), depth0))
    + "\"/>\n</div>\n<div class=\"show-for-medium-only\">\n  <img class=\"hero-image\" alt=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"backgroundImage") : stack1)) != null ? lookupProperty(stack1,"altTag") : stack1), depth0))
    + "\" src=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"backgroundImage") : stack1)) != null ? lookupProperty(stack1,"srcMedium") : stack1), depth0))
    + "\"/>\n</div>\n<div class=\"show-for-large-up\">\n  <img class=\"hero-image\" alt=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"backgroundImage") : stack1)) != null ? lookupProperty(stack1,"altTag") : stack1), depth0))
    + "\" src=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"backgroundImage") : stack1)) != null ? lookupProperty(stack1,"srcLarge") : stack1), depth0))
    + "\"/>\n</div>\n\n<div class=\"small-12 column background-styles\">\n  <div id=\"outer-box\">\n    <div class=\"trans-box\">\n      <div class=\"row\">\n        <div class=\"article-title\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"headLine") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":10},"end":{"line":18,"column":17}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"copyText") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":10},"end":{"line":21,"column":17}}})) != null ? stack1 : "")
    + "        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.auto-loans.modules/article-engagement-auto-module",
  "version": "1.0.0",
  "id": "article-engagement-auto-module",
  "containerID": "autoLoansArticleEngagementAutoModule",
  "moduleName": "auto-loans-article-engagement-auto-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "article-engagement-auto-module",
  "data": {
    "init": "AutoLoansArticleEngagementAutoModule"
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.helpers/utils-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7"
  },
  "stores": []
};

/**
 * @export
 * @class ArticleEngagementAutoModuleJS
 * @extends {Module}
 */
class ArticleEngagementAutoModule extends Module {
  /**
   * @param {Object} options undefined
   * @param {Object} context undefiend
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
    * @return {void}
    */
  init() {}
}
registerModuleClass({
  moduleClass: ArticleEngagementAutoModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ArticleEngagementAutoModule as default, moduleConfig };
